module.exports = __webpack_public_path__ + "img/google.098a7b2d.svg";